module.exports = __webpack_public_path__ + "img/books.0031a133.png";